import {Component} from '@angular/core';
import {Shared} from "../shared/shared";

@Component({
  selector: 'app-menu-professor',
  templateUrl: 'menuProfessor.html',
  styleUrls: ['menuProfessor.scss']
})
export class MenuProfessor {

  constructor(private shared: Shared) {}
}
